import {
	ADD_REPORT_SUCCESS,
	ADD_REPORT_FAIL,
	GET_REPORT_SUCCESS,
	GET_REPORT_FAIL,
	GET_REPORTS_SUCCESS,
	GET_REPORTS_FAIL,
	UPDATE_REPORT_SUCCESS,
	UPDATE_REPORT_FAIL,
	SET_REPORT_LOADING,
	CLEAR_REPORT_ERROR,
	DELETE_REPORT_SUCCESS,
	DELETE_REPORT_FAIL,
} from './types';

const initialState = {
	loading: false,
	report: null,
	reports: [],
	error: null,
};

const reportReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_REPORT_LOADING:
			return {
				...state,
				loading: true,
			};

		case CLEAR_REPORT_ERROR:
			return {
				...state,
				error: null,
				updated: false,
				report: null,
			};

		case ADD_REPORT_SUCCESS:
			return {
				...state,
				report: action.payload,
				loading: false,
			};

		case GET_REPORTS_SUCCESS:
			return {
				...state,
				reports: action.payload,
				loading: false,
				error: null,
			};

		case GET_REPORT_SUCCESS:
			return {
				...state,
				report: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_REPORT_SUCCESS:
			return {
				...state,
				report: action.payload,
				updated: true,
				loading: false,
				reports: state.reports.map((report) => {
					if (report._id === action.payload._id) {
						return action.payload;
					} else {
						return report;
					}
				}),
			};

		case DELETE_REPORT_SUCCESS:
			return {
				...state,
				reports: state.reports.filter((report) => report._id !== action.payload),
				loading: false,
			};

		case GET_REPORTS_FAIL:
		case GET_REPORT_FAIL:
		case UPDATE_REPORT_FAIL:
		case ADD_REPORT_FAIL:
		case DELETE_REPORT_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export default reportReducer;
